import { render, staticRenderFns } from "./Registereduser.vue?vue&type=template&id=538e1104"
import script from "./Registereduser.vue?vue&type=script&lang=js"
export * from "./Registereduser.vue?vue&type=script&lang=js"
import style0 from "./Registereduser.vue?vue&type=style&index=0&id=538e1104&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QDialog,QCard,QCardSection,QInput,QBtn});
